export const DEFAULT_EASING = [0.66, 0.05, 0.05, 0.98];
export const EASE_IN_OUT = [0, 0.0, 0.2, 1];
